<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="导出选项"
    width="600px"
    @close="handleClose"
  >
    <el-form :model="exportOptions">
      <el-form-item label="格式">
        <el-select v-model="exportOptions.format" placeholder="请选择导出格式">
          <el-option label="Draw.io (推荐)" value="drawio" />
          <el-option label="PNG" value="png" />
          <el-option label="JPEG" value="jpeg" />
        </el-select>
      </el-form-item>
      <el-form-item label="背景" v-if="exportOptions.format !== 'drawio'">
        <el-radio-group v-model="exportOptions.background">
          <el-radio label="transparent">透明背景</el-radio>
          <el-radio label="white">白色背景</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-else>
        <div class="drawio-info">
          <div class="info-title">
            <i class="el-icon-info"></i>
            为什么选择 Draw.io 格式?
          </div>
          <div class="info-items">
            <div class="info-item">
              <i class="el-icon-edit"></i>
              可以在 Draw.io 中进一步编辑和美化图表
            </div>
            <div class="info-item">
              <i class="el-icon-download"></i>
              支持导出为多种格式：SVG、PNG、JPEG、PDF、Visio等
            </div>
            <div class="info-item">
              <i class="el-icon-share"></i>
              方便分享和协作，支持在线编辑
            </div>
            <div class="info-item">
              <i class="el-icon-document"></i>
              完整保留图表的所有元素和关系
            </div>
          </div>
        </div>
        <div class="usage-tips">
          <div class="tips-content">
            <span class="tips-label">使用提示</span>
            <p>导出后可以使用 <el-link type="primary" href="https://app.diagrams.net/" target="_blank">Draw.io 在线版</el-link> 或桌面版继续编辑。</p>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">导出</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExportDialog',
  
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      exportOptions: {
        format: 'drawio',
        background: 'transparent'
      }
    }
  },

  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },

  methods: {
    handleClose() {
      this.dialogVisible = false
    },

    handleConfirm() {
      this.$emit('confirm', this.exportOptions)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.drawio-info {
  background-color: #f5f7fa;
  border-radius: 4px;
  padding: 16px;
  width: 100%;
}

.drawio-info .info-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #409EFF;
  font-size: 14px;
  margin-bottom: 16px;
}

.drawio-info .info-title i {
  font-size: 16px;
}

.drawio-info .info-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.drawio-info .info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #606266;
}

.drawio-info .info-item i {
  color: #67c23a;
  font-size: 14px;
}

.usage-tips {
  margin-top: 16px;
  background-color: #fafafa;
  border-radius: 4px;
  width: 100%;
}

.usage-tips .tips-content {
  padding: 12px 16px;
}

.usage-tips .tips-label {
  color: #909399;
  font-size: 13px;
  display: block;
}

.usage-tips p {
  margin: 8px 0 0;
  font-size: 13px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 4px;
}

.usage-tips p:first-of-type {
  margin-top: 12px;
}

.usage-tips p .el-link {
  margin: 0;
  font-size: inherit;
}
</style>
